import { useEffect, useRef } from "react"
import didSaySomething from '../functions/didSaySomething'

export default function useDetectStudentDidSaySomething({volumeStats}) {

    const studentDidSaySomething = useRef(false)

    useEffect(()=>{
        const {maxVolume, minVolume} = volumeStats
        if(didSaySomething(volumeStats) && !studentDidSaySomething.current){
            studentDidSaySomething.current = true
        }
    }, [volumeStats.instant])

    const resetDidSaySomething = () => studentDidSaySomething.current = false

    return {studentDidSaySomething, resetDidSaySomething}
}